import { Component, OnInit } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';

@Component({
  selector: 'app-token-expire',
  templateUrl: './token-expire.component.html',
  styleUrls: ['./token-expire.component.css']
})
export class TokenExpireComponent implements OnInit {

  constructor(private jwtHelper: JwtHelperService,
    private router: Router) { }

  ngOnInit() {
    if (this.jwtHelper.isTokenExpired()) {
      this.router.navigate(['/token-expire'])
    }
  }

}
